import { z } from "zod";
import { AgreementId, AgreementSignatureStatusOptions, SignatureRequestId, } from "../../Types";
export const HellosignAgreement = z.object({
    agreementId: AgreementId,
    signatureRequestId: SignatureRequestId.nullish(),
    title: z.string(),
    status: z.enum(AgreementSignatureStatusOptions),
});
export const DisclosureType = z.enum(["privacyPolicy", "adv", "crs"]);
//# sourceMappingURL=types.js.map